import { Loader } from "@app/components/core/Loader/Loader"
import Button from "@app/components/move2Library/Button/Button"
import Input from "@app/components/move2Library/Input/Input"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { useRaiseError } from "@app/store/actions/errorActions"
import { addThermencardLine } from "@app/store/actions/orderActions"
import { useGetBankTemplate, useGetMyParadiseImages, useGetStrings } from "@app/store/service/cmsService"
import { useCreateNewBankAccount, useDeleteBankAccount, useGetBankHistory, useGetThermencardBankAccount } from "@app/store/service/connectorService"
import { getDateString, getPriceString } from "@app/utils/localeUtils"
import { emailPattern } from "@app/utils/validations"
import { faCircleArrowDown } from "@fortawesome/free-solid-svg-icons/faCircleArrowDown"
import { faCircleArrowUp } from "@fortawesome/free-solid-svg-icons/faCircleArrowUp"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Modal, classNamez, useModal } from "@tecreation/funnel-components"
import { AnimatePresence, m } from "framer-motion"
import { useCallback, useState } from "react"
import { useForm } from "react-hook-form"
import "./MyParadiseThermencardModal.css"
export const MyParadiseThermencardModal = () => {
	const [currentBankTemplate, setCurrentBankTemplate] = useState()
	const { data: image } = useGetMyParadiseImages(undefined, { defaultData: [] })
	const [deleteBankAccount] = useDeleteBankAccount()
	const [createBankAccount] = useCreateNewBankAccount()
	const { data: account, refetch, isFetching } = useGetThermencardBankAccount()
	const { data: strings } = useGetStrings(undefined, { defaultData: {} })
	const { data: bankTemaplates } = useGetBankTemplate()

	let newDate = new Date()
	const [dateTo, setDateTo] = useState(new Date(newDate))
	const [dateFrom, setDateFrom] = useState(new Date(newDate.getFullYear() - 5, newDate.getMonth(), newDate.getDate()))

	const { data: accountHistory } = useGetBankHistory(
		{
			scanCode: account ? account.scanCode : "",
			dateFrom: dateFrom.toISOString().slice(0, 10),
			dateTo: dateTo.toISOString().slice(0, 10),
		},
		{ skip: account == undefined },
	)

	const [isSalesCollpaseOpen, setIsSalesCollapseOpen] = useState(false)
	const [isReachargeCollpaseOpen, setIsReachargeCollapseOpen] = useState(false)
	const { push } = useCustomNavigation()
	const { hideModal } = useModal()

	const raiseError = useRaiseError()

	const thermenCardImage = image.find(i => i.type === "thermencard")
	const {
		labelDate,
		labelDateTo,
		labelDateFrom,
		buttonAddToCart,
		thermencardModalHeader,
		thermencardModalSubText,
		thermencardModalRemoveCard,
		thermencardModalSalesHeader,
		thermencardModalAddCreditHeader,
		thermencardModalCardPlaceholder,
		thermencardModalCardActivateButton,
		thermencardModalAmount,
		thermencardModalCredit,
		thermencardLocked,
		placeholderEMail,
		errorInputMissingEmail,
		errorInputInvalidEmail,
		errorInputMissingCardNumber,
	} = strings
	const deleteThermencard = async () => {
		let result = await deleteBankAccount({ accountId: account.accountId })
		if (result) {
			hideModal()
			refetch()
		}
	}
	const purchaseCredit = () => {
		if (!currentBankTemplate) return

		let template = bankTemaplates.find(t => t.accountTemplateId == currentBankTemplate)
		addThermencardLine({
			accountToken: account.accountToken,
			accountTemplateId: Number(template.accountTemplateId),
			amount: Number(template.price),
			accountTemplate: template.accountTemplate,
		})
		push("order/order-overview")
		hideModal()
	}
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		mode: "onTouched",
		defaultValues: {
			thermencardNum: "",
			email: "",
		},
	})
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const onSubmit = useCallback(async () => {
		handleSubmit(async data => {
			let email = data.email
			let scanCode = data.thermencardNum
			try {
				const result = await createBankAccount({ email, scanCode }).unwrap()
				result && refetch()
				hideModal()
			} catch (e) {
				raiseError(e)
			}
		})()
	})

	return (
		<Modal className="customModal">
			<Modal.Header>{thermencardModalHeader}</Modal.Header>
			<Modal.Closer />
			<Modal.Body>
				<div className="w-100 flex flex-column flex-items-center">
					<p className="color-fg-default">{thermencardModalSubText}</p>
					<img
						src={thermenCardImage?.image}
						width="200"
						height="125"
						className="mt-3"
						style={{
							filter: account?.lock === true ? "opacity(0.5)" : "initial",
						}}
					/>

					{account ? (
						<>
							<h3 className="mt-3 color-fg-secondary">{getPriceString(account.amount)} Guthaben</h3>
							<p className="mt-1 color-fg-secondary">{account.exportCode}</p>
							{account.lock === true && <p className="mt-1 color-fg-red-700">{thermencardLocked}</p>}
							<div className="w-100 flex flex-column flex-items-center">
								<Button style="secondary" onClick={deleteThermencard} className="mt-4 mb-5">
									{thermencardModalRemoveCard}
								</Button>

								<div className="flex w-100 border-top color-border-secondary flex-justify-between pt-3 mb-3">
									<h4>{thermencardModalSalesHeader} </h4>
									<FontAwesomeIcon
										size="xl"
										className="color-fg-secondary-700"
										icon={isSalesCollpaseOpen ? faCircleArrowUp : faCircleArrowDown}
										onClick={() => setIsSalesCollapseOpen(isSalesCollpaseOpen ? false : true)}
									/>
								</div>
								<AnimatePresence>
									{isSalesCollpaseOpen && (
										<m.div
											className="z-9 of-hidden w-100"
											style={{ originY: 0 }}
											initial={{
												key: "modal",
												height: 0,
											}}
											animate={{
												height: "auto",
												transition: {
													duration: 0.3,
												},
											}}
											exit={{
												height: 0,
												transition: { duration: 0.3 },
											}}
										>
											<div>
												<span className="flex flex-justify-center f2 mb-3">Filter</span>
												<div className="flex flex-justify-center mb-4">
													<Input
														type="date"
														label={labelDateFrom}
														value={dateFrom.toISOString().slice(0, 10)}
														onChange={e => {
															let d = new Date(e.target.value)
															if (!isNaN(d.getTime())) {
																setDateFrom(d)
															}
														}}
														className="mr-3"
													/>
													<Input
														type="date"
														label={labelDateTo}
														value={dateTo.toISOString().slice(0, 10)}
														onChange={e => {
															let d = new Date(e.target.value)
															if (!isNaN(d.getTime())) {
																setDateTo(d)
															}
														}}
													/>
												</div>
												{accountHistory && (
													<>
														{Object.keys(accountHistory).map((key, index) => {
															return (
																<div className={classNamez({ "color-bg-secondary-100": false })} key={key + ";" + index}>
																	<div className="mb-0 p-2 w-100">
																		<span className="f3 mr-4 border-bottom color-border-primary w-100 block">
																			{labelDate}: {getDateString(new Date(key))}
																		</span>
																		<div>
																			{Array.isArray(accountHistory[key])
																				? accountHistory[key].map((history, index) => {
																						let v = history.TotalPrice * (history.Type == 2 ? -1 : 1)

																						return (
																							<div className="w-100 flex my-1 py-2 px-2" key={history.TimeStamp + ";" + index}>
																								<span className="f4">
																									{history.Type === 1 && <>{history.SaleShortText || "Auszahlung"}</>}
																									{history.Type === 0 && <>Einzahlung</>}
																									{history.Type === 2 && (
																										<>
																											{history.SaleAmount}x {history.SaleShortText}
																										</>
																									)}
																								</span>
																								<span
																									className={
																										"f4 ml-auto" +
																										classNamez({
																											"color-bg-green-100": v > 0,
																											"color-bg-red-100": v < 0 || history.Type == 2,
																										})
																									}
																								>
																									{v <= 0 ? "" : "+"}
																									{getPriceString(v)}
																								</span>
																							</div>
																						)
																					})
																				: null}
																		</div>
																	</div>
																</div>
															)
														})}
													</>
												)}
											</div>
										</m.div>
									)}
								</AnimatePresence>

								{!account?.lock && (
									<div className="flex w-100 border-top color-border-secondary flex-justify-between pt-3">
										<h4>{thermencardModalAddCreditHeader}</h4>
										<FontAwesomeIcon
											size="xl"
											style={{ color: "var(--color-secondary-700)" }}
											icon={isReachargeCollpaseOpen ? faCircleArrowUp : faCircleArrowDown}
											onClick={() => {
												if (isReachargeCollpaseOpen) {
													setCurrentBankTemplate(undefined)
												}
												setIsReachargeCollapseOpen(isReachargeCollpaseOpen ? false : true)
											}}
										/>
									</div>
								)}

								<AnimatePresence>
									{isReachargeCollpaseOpen && (
										<m.div
											className="z-9 of-hidden w-100"
											style={{ originY: 0 }}
											initial={{
												key: "modal",
												height: 0,
											}}
											animate={{
												height: "auto",
												transition: {
													duration: 0.3,
												},
											}}
											exit={{
												height: 0,
												transition: { duration: 0.3 },
											}}
										>
											{bankTemaplates &&
												bankTemaplates.map((template, i) => {
													if (template.accountGroupId.isEmployee) {
														return null
													}
													return (
														<div key={i} className="mt-2">
															<div className="flex flex-items-center">
																<input
																	style={{ border: "0px", height: "1.2em" }}
																	type="radio"
																	id={template.bankAccountTemplate_id}
																	name="bankTemplate"
																	value={template.accountTemplateId}
																	onChange={e => {
																		setCurrentBankTemplate(e.target.value)
																	}}
																/>
																<label className=" f5 ml-1 pt-1 color-fg-primary" htmlFor={template.accountTemplate}>
																	{getPriceString(template.amount) + ` ${thermencardModalCredit}`}
																</label>
															</div>
															<h5 className="mt-1 pl-4 color-fg-secondary">{`${thermencardModalAmount} ` + getPriceString(template.price)}</h5>
														</div>
													)
												})}
											<Button style="secondary" className="mt-4" onClick={purchaseCredit}>
												{buttonAddToCart}
											</Button>
										</m.div>
									)}
								</AnimatePresence>
								{currentBankTemplate}
							</div>
						</>
					) : !isFetching ? (
						<div className="w-100 flex flex-column flex-items-center">
							<div className="thermencardModal__inputRow thermencardModal__inputRow--3 mt-8 w-100">
								<div>
									<Input
										name="thermencardNum"
										type="text"
										label={thermencardModalCardPlaceholder + "*"}
										formRegister={register("thermencardNum", {
											required: {
												value: true,
												message: errorInputMissingCardNumber,
											},
										})}
										errors={errors}
									/>
								</div>
								<div>
									<Input
										name="email"
										type="email"
										label={placeholderEMail + "*"}
										autocomplete="email"
										formRegister={register("email", {
											required: {
												value: true,
												message: errorInputMissingEmail,
											},
											pattern: {
												value: emailPattern,
												message: errorInputInvalidEmail,
											},
										})}
										errors={errors}
									/>
								</div>
							</div>
							<div className="mt-4">
								<Button onClick={onSubmit} style="secondary">
									{thermencardModalCardActivateButton}
								</Button>
							</div>
						</div>
					) : (
						<Loader show />
					)}
				</div>
			</Modal.Body>
		</Modal>
	)
}
